import { parseJsonProperties } from './jsonProperties'

export function parseNotificationProperties(properties) {
  return parseJsonProperties(properties)
}

export function notificationPdfUrl(notification) {
  if (notification?.generate_url) return notification.generate_url

  const props = parseNotificationProperties(notification?.properties)
  const submissionId = props.submissionId || props.submission_id
  if (!submissionId) return null

  switch (props.kind) {
    case 'material':
      return `/api/v1/materialorder/v1/generate/${submissionId}`
    case 'timesheet':
      return `/api/v1/timesheet/v1/generate/${submissionId}`
    case 'custom':
    default:
      return `/api/v1/pdfreport/v1/generate/${submissionId}`
  }
}

export function openSubmissionPdfAndList(notification, router, openWindow = window.open) {
  const pdfUrl = notificationPdfUrl(notification)
  if (pdfUrl) {
    openWindow(pdfUrl, '_blank', 'noopener')
  }
  router.push('/forms/submissions')
  return pdfUrl
}

export function notificationRoute(notification) {
  const pdfUrl = notificationPdfUrl(notification)
  if (pdfUrl) return { href: pdfUrl }

  const category = notification?.category || ''
  if (category === 'submission' || category === 'audit') {
    return { route: '/forms/submissions' }
  }
  return { route: '/notifications' }
}

export function reminderRoute(reminder) {
  const props = parseNotificationProperties(reminder?.properties)
  const key = props.key || ''

  if (key.startsWith('cert:')) {
    const id = key.slice(5)
    return id ? `/resource/${id}` : '/hr'
  }
  if (key.startsWith('maint:')) {
    return '/maintenance'
  }

  switch (reminder?.category) {
    case 'certification':
      return '/hr'
    case 'maintenance':
      return '/maintenance'
    default:
      return '/reminders'
  }
}
